module.exports = __webpack_public_path__ + "static/media/Plant Shop Color.1af99af2.png";